/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Notfound_Subtext_MaybeInputs */



/**
* | output |
* | --- |
* | "Maybe it was here once, maybe it never was." |
*
* @param {Error_Notfound_Subtext_MaybeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_notfound_subtext_maybe = /** @type {((inputs?: Error_Notfound_Subtext_MaybeInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Notfound_Subtext_MaybeInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vielleicht war sie mal hier, vielleicht nie.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Peut-être qu'elle a existé, peut-être jamais.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("也许它曾经在这里，也许从来都不在。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("也許它曾經在這裡，也許從來沒有過。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("예전에 있었을 수도, 처음부터 없었을 수도 있습니다.")
	return /** @type {LocalizedString} */ ("Maybe it was here once, maybe it never was.")
});